import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=2b1b002f&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=2b1b002f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1b002f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b1b002f')) {
      api.createRecord('2b1b002f', component.options)
    } else {
      api.reload('2b1b002f', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=2b1b002f&scoped=true&", function () {
      api.rerender('2b1b002f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KcmWR5hIX4D8/JS/comp/DateRangeExt.vue"
export default component.exports